import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiNavigation } from '@taiga-ui/layout';
import { TuiDialogService, TuiIcon, TuiLoader, TuiTitle } from '@taiga-ui/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TUI_CONFIRM, TuiSwitch } from '@taiga-ui/kit';
import { ApplicationStore, MemberStore, ProjectStore } from '@ffx/app-store';
import { tap } from 'rxjs';
import { FeatureFlagService } from '@ffx/feature-flags';

@Component({
    selector: 'ffx-desktop-menu',
    standalone: true,
    imports: [CommonModule, TuiNavigation, FormsModule, TuiSwitch, TuiIcon, TuiLoader, TuiTitle, RouterModule],
    templateUrl: './desktop-menu.component.html',
    styleUrl: './desktop-menu.component.scss'
})
export class DesktopMenuComponent implements OnInit {
    @Input() isDarkMode = true;
    @Output() toggleDarkModeEvent: EventEmitter<void> = new EventEmitter<void>();
    private route = inject(ActivatedRoute);
    private readonly dialogService = inject(TuiDialogService);
    private projectStore = inject(ProjectStore);
    private memberStore = inject(MemberStore);
    private appStore = inject(ApplicationStore);
    private featureFlagService = inject(FeatureFlagService);

    protected isOwner$ = this.projectStore.isOwner;
    projectSettingsLoading$ = this.projectStore.projectSettingsLoading;
    leaveProjectLoading$ = this.memberStore.leaveProjectLoading;
    id!: string;
    showHistory = this.featureFlagService.isFlagActive('history');

    ngOnInit(): void {
        this.id = this.route.snapshot.paramMap.get('id') ?? '';
    }

    toggleDarkMode(): void {
        this.toggleDarkModeEvent.emit();
    }

    // TODO: Make custom dialog service
    exitProjectConfirmation(): void {
        this.dialogService
            .open<boolean>(TUI_CONFIRM, {
                label: `Are you sure you want to leave the '${this.projectStore.selectedProject().name}' project? You will have to ask an owner to add you again if you change your mind.`,
                size: 's',
                data: { yes: 'Leave', no: 'Cancel' }
            })
            .pipe(
                tap((confirmDelete: boolean) => {
                    if (confirmDelete) {
                        const selectedProject = this.projectStore.selectedProject();
                        this.memberStore.leaveProject(
                            selectedProject.name,
                            this.appStore.user().uid,
                            selectedProject.id
                        );
                    }
                })
            )
            .subscribe();
    }
}
